const project = {
  slug: "nestable-talent-pool-dashboard",
  title: "Nestable Talent Pool - Live Analytics Dashboard",
  oneLiner: "Internal hiring dashboard with live analytics sourced from a Google Sheet.",
  role: ["Full-stack Developer", "Frontend Engineer"],
  category: "Web Development",
  clientOrOrg: "Nestable",
  timeframe: { start: "2026-04", status: "Shipped" },
  domain: ["TalentOps", "Internal Tools", "Analytics"],
  tech: ["React", "JSX", "Google Sheets API", "Chart.js", "CSS"],
  links: {},
  gallery: [
    {
      src: "/assets/nestable-talent-pool/nestable-talent-pool-1.png",
      alt: "Nestable Talent Pool Dashboard - A React-based internal dashboard showing KPIs, charts, and a candidate table for Nestable's hiring pipeline"
    },
    {  
      src: "/assets/nestable-talent-pool/nestable-talent-pool-2.png",
      alt: "Nestable Talent Pool Dashboard - A React-based internal dashboard showing KPIs, charts, and a candidate table for Nestable's hiring pipeline"
    },
  ],
  impact: [
    "Surfaces 77+ candidates in a single live view, replacing manual spreadsheet triage.",
    "Tracks resume, LinkedIn, GitHub and email coverage at a glance so recruiters spot gaps instantly.",
    "Auto-refreshes from the source Google Sheet so the team always sees the latest pipeline state."
  ],
  responsibilities: [
    "Designed the dashboard layout and KPI tile system around recruiter workflows.",
    "Built the React + JSX frontend with reusable chart and filter components.",
    "Wired the Google Sheets data source into the app with a refresh-on-demand sync.",
    "Implemented multi-axis filtering (role, status, location, talent pool, tech, English)."
  ],
  features: [
    "Six headline KPIs: total candidates, with resume, LinkedIn linked, GitHub linked, with email, fluent English",
    "Free-text search across name, email, role, and location",
    "Filters by role, status, location, talent pool segment, tech, and English level",
    "Donut charts for candidate status and talent pool segments",
    "Horizontal bar charts for top roles applied for, top locations, and top tech stacks",
    "Paginated candidates table with quick links to CV, LinkedIn, and GitHub",
    "Manual refresh button with last-updated timestamp"
  ],
  architecture: [
    "React (JSX) single-page app",
    "Google Sheet as the source of truth, read via the Sheets API",
    "Chart.js for donut and bar visualisations",
    "Component-scoped CSS, no framework styling"
  ],
  seo: {
    title: "Nestable Talent Pool - Live Hiring Analytics Dashboard",
    description:
      "Internal React dashboard for Nestable that turns a recruiting Google Sheet into live KPIs, charts, and a filterable candidate table."
  },
  cover: "/assets/nestable-talent-pool/nestable-talent-pool-featured.png"
};

export default project;
